<template>
  <router-view></router-view>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'
import db from './components/firebaseInit'
import * as moment from 'moment'
import 'moment/locale/pt-br'
import 'material-design-lite'

export default {
  name: 'App',
  computed: {
    currentName: function() {
      return localStorage.getItem('currentName')
    },
    css_import: function() {
      return process.env.CSS_IMPORT
    }
  },
  methods: {
    logout: function () {
      localStorage.setItem('currentUser', null)
      document.getElementsByClassName('mdl-layout__drawer')[0].classList.remove('is-visible')
      document.getElementsByClassName('mdl-layout__obfuscator')[0].classList.remove('is-visible')
      this.$router.push("/login");
    }
  }
}
</script>

<style>
  @import url('../static/css/material.icons.css');
  @import url('../static/css/material.teal-blue.min.css');
  body {
    background-color: #eee;
  }
.loader,
.loader:before,
.loader:after {
  background: #40B784;
  -webkit-animation: load1 1s infinite ease-in-out;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 4em;
}
.loader {
  color: #40B784;
  text-indent: -9999em;
  margin: 50px auto;
  position: relative;
  font-size: 11px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;

}
.loader:before,
.loader:after {
  position: absolute;
  top: 0;
  content: '';
}
.loader:before {
  left: -1.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 1.5em;
}
@-webkit-keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
@keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
.welcome-card {
  margin-top: 19px;
}
.pull-left {
  float: left;
}
.pull-right {
  float: right;
}
.center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue